import "core-js/modules/es.promise.js";
import { ENV_ANDROID } from '../../const';
import { env } from '../../getNativeInfo';
import { prepareApi } from '../../utils';
prepareApi(['bcz_system']);
/**
 * 上传图片文件
 *
 * *该方法只适用于 Android 设备，因为 Android Web View 的 `<input type='file'/>` 标签选择本地文件功能存在操作系统版本适配问题，所以由客户端单独实现上传功能*
 *
 */

export function uploadImage(_a) {
  var name = _a.name,
      url = _a.url,
      _b = _a.maxSaveSize,
      maxSaveSize = _b === void 0 ? 500 : _b,
      onStart = _a.onStart,
      onSuccess = _a.onSuccess,
      onFailed = _a.onFailed;
  return new Promise(function (resolve, reject) {
    if (env !== ENV_ANDROID) {
      reject(new Error('Not in app or Android'));
      return;
    }

    window.bcz_system.onPostImageUploadState = function (result) {
      try {
        var response = JSON.parse(result);

        switch (response.state) {
          case -1:
            {
              onFailed === null || onFailed === void 0 ? void 0 : onFailed(response);
              reject(new Error('Upload File failed! ' + JSON.stringify(response)));
              break;
            }

          case 0:
            {
              onStart === null || onStart === void 0 ? void 0 : onStart();
              break;
            }

          case 1:
            {
              onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(JSON.parse(response.msg));
              resolve(JSON.parse(response.msg));
              break;
            }
        }
      } catch (err) {
        reject(err);
      }
    };

    var params = JSON.stringify({
      fieldName: name,
      url: url,
      maxSaveSize: maxSaveSize
    });
    window.bcz_system.uploadImage(params);
  });
}
/**
 * 上传图片文件
 * @deprecated Use `uploadImage` instead
 */

export var uploadFile = uploadImage;